import { useContext } from "react";
import CsrfContext from "@contexts/csrf_context";

const useCsrfToken = () => useContext(CsrfContext);

export default useCsrfToken;
